"use strict";
// Additional project-domain enumerations — project type, project form-status
// key, payment mode. Consolidated from backend pm/types and frontend
// utils/enums.
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMode = exports.ProjectFormStatusType = exports.ProjectFormStatusType_ = exports.ProjectType = void 0;
exports.ProjectType = {
    VERANDA: 'VERANDA',
    PERGOLA: 'PERGOLA',
    POOL: 'POOL',
};
// The "form status type" discriminant — which sub-form or section a status
// record pertains to. Merged shape of backend's PROJECT_FORM_STATUS_TYPE
// (11 members) and frontend's ProjectFormType (6 members).
exports.ProjectFormStatusType_ = {
    DECLARER: 'DECLARER',
    LAND: 'LAND',
    EXISTING_BUILDING: 'EXISTING_BUILDING',
    VERANDA: 'VERANDA',
    PERGOLA: 'PERGOLA',
    POOL: 'POOL',
    PROJECT: 'PROJECT',
    PC: 'PC',
    DP: 'DP',
    PCM: 'PCM',
    URBAN_ANALYSIS: 'URBAN_ANALYSIS',
};
exports.ProjectFormStatusType = exports.ProjectFormStatusType_;
exports.PaymentMode = {
    IMMEDIATE: 'IMMEDIATE',
    END_OF_MONTH: 'END_OF_MONTH',
};
//# sourceMappingURL=types.js.map